import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  makeStyles
} from "@material-ui/core";
import { Controller, UseFormReturn } from "react-hook-form";
import { SecondFormValues } from "../utils/form-values";
import locale from "@bonliva-crm/locale";

type Props = {
  form: UseFormReturn<SecondFormValues, any, SecondFormValues>;
  presentationUrl: string | null;
};

export const SecondStep = ({ form: { control }, presentationUrl }: Props) => {
  const classes = useStyles();

  const presentationPreviewUrl = presentationUrl ? new URL(presentationUrl) : undefined;
  presentationPreviewUrl && presentationPreviewUrl.searchParams.set("withLinks", "");

  return (
    <Box className={classes.root}>
      {presentationPreviewUrl && (
        <div className={classes.iframeWrapper}>
          <iframe
            title={presentationPreviewUrl.toString()}
            className={classes.iframe}
            src={presentationPreviewUrl.toString()}
          />
        </div>
      )}
      <FormControl component="fieldset" style={{ marginLeft: "3px" }}>
        <section>
          <Controller
            render={({ field }) => (
              <FormControlLabel
                {...field}
                control={<Checkbox />}
                label={locale.ConsultantPresentationGuarantee}
              />
            )}
            name="presentationVerified"
            control={control}
          />
        </section>
      </FormControl>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    rowGap: "1rem",
    overflow: "hidden"
  },
  iframe: {
    height: "75vh",
    border: 0,
    flex: 1,
    zIndex: 10,
    overflow: "hidden"
  },
  iframeWrapper: {
    flex: 1,
    display: "flex",
    position: "relative",
    minHeight: "10vh",
    overflow: "auto"
  }
}));
